'use client';

import { Stack } from '@mui/material';
import IdentityCard from './IdentityCard';
import tokens from '@verifime/design-tokens';
import { IdentityStatus, IdentityType, TIdentity } from '../types';
import CreateNewidentity from './CreateNewIdentity';

export interface IdentityCardsProps {
  allIdentity: TIdentity[];
  onClickIdentity: ({
    index,
    id,
    type,
    status,
  }: {
    index: number;
  } & Omit<TIdentity, 'name'>) => void;
  onClickAddNewIdentity?: () => void;
  hideAddNewIdentity?: boolean;
}

export default function IdentityCards({
  allIdentity,
  onClickIdentity,
  onClickAddNewIdentity,
  hideAddNewIdentity = false,
}: IdentityCardsProps) {
  const canCreateNewIdentity =
    !hideAddNewIdentity &&
    allIdentity.filter(
      (identity) =>
        identity.type === IdentityType.INDIVIDUAL &&
        [IdentityStatus.VERIFIED, IdentityStatus.IN_PROGRESS, IdentityStatus.REJECTED].includes(
          identity.status,
        ),
    ).length > 0;

  return (
    <>
      <Stack
        direction="row"
        justifyContent="flex-start"
        justifyItems="flex-start"
        gap={tokens.spacingLg}
        flexWrap="wrap"
      >
        {allIdentity.map((identity, index) => (
          <IdentityCard
            {...identity}
            key={index}
            onClick={() =>
              onClickIdentity({
                index,
                id: identity.id,
                type: identity.type,
                status: identity.status,
              })
            }
          />
        ))}
        {canCreateNewIdentity && <CreateNewidentity onAdd={onClickAddNewIdentity} />}
      </Stack>
    </>
  );
}
